/**
 * Created by maximus on 08.11.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactBootstrap = require('react-bootstrap');

var _components2 = require('components');

require('./Paginator.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Paginator: {
        displayName: 'Paginator'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Paginator/default/PaginatorView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Paginator = _wrapComponent('Paginator')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(Paginator, _Component);

    function Paginator(props) {
        (0, _classCallCheck3.default)(this, Paginator);
        return (0, _possibleConstructorReturn3.default)(this, (Paginator.__proto__ || (0, _getPrototypeOf2.default)(Paginator)).call(this, props));
    }

    (0, _createClass3.default)(Paginator, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                activePage = _props.activePage,
                count = _props.count,
                pages = _props.pages,
                limitsArray = _props.limitsArray,
                limit = _props.limit,
                lang = _props.lang;


            return _react3.default.createElement(
                'div',
                { className: 'pagination-holder' },
                _react3.default.createElement(
                    'div',
                    { className: 'my_pagination row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12  col-sm-6' },
                        pages > 1 ? _react3.default.createElement(_reactBootstrap.Pagination, {
                            activePage: activePage,
                            boundaryLinks: true,
                            items: pages,
                            maxButtons: 3,
                            onSelect: this.props.handleChangeActivePage
                        }) : null
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12  col-sm-6  text-right' },
                        count < limit && count < limitsArray[0] ? null : _react3.default.createElement(
                            'div',
                            { className: 'drop_down_limit' },
                            _react3.default.createElement(
                                'div',
                                { className: 'drop_down_limit_label' },
                                lang['store.paginator.quantity'],
                                ':'
                            ),
                            _react3.default.createElement(_components2.DropdownSelect, {
                                onChange: this.props.handleChangeSelect,
                                title: limit,
                                selected: limitsArray.indexOf(limit + ''),
                                items: limitsArray
                            })
                        )
                    )
                )
            );
        }
    }]);
    return Paginator;
}(_react2.Component), _class.propTypes = {
    activePage: _react2.PropTypes.any,
    handleChangeActivePage: _react2.PropTypes.func.isRequired,
    handleChangeSelect: _react2.PropTypes.func.isRequired,
    limit: _react2.PropTypes.any,
    limitsArray: _react2.PropTypes.any,
    pages: _react2.PropTypes.number,
    lang: _react2.PropTypes.object
}, _temp));

exports.default = Paginator;
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Paginator/default/PaginatorView.jsx
// module id = 1717
// module chunks = 0